<template>
  <div>
      <van-popup
      v-model="showReply"
      :style="{ height: '100%', width: '100%', background: '#f9f9f9', transform: 'none !important', top: '0', left: '0' }">
      <div class="add-pep">
        <van-nav-bar style="flex:1">
          <div slot="left" @click="close">
            <van-icon name="arrow-left" color="#333" size="19" />
          </div>
          <div slot="title">添加批复</div>
        </van-nav-bar>
        <div class="reply-wrap">
          <div class="van-hairline--surround text">
            <van-cell-group>
              <van-field
                v-model="message"
                type="textarea"
                placeholder="请输入批复内容"
                maxlength='300'
                autosize
                rows='10'
                :style="{ padding: '2.7vh 4.8vw'}"
              />
            </van-cell-group>
          </div>
          <div class="addFile">
            <button class="add-btn">
              <input type="file" ref="fileAll" multiple="multiple" @change="changeFunc($event)" style="position:absolute;top:0;left:0;width:100%;height:100%;opacity:0;">
              <div class="btn-box">
                <van-icon name="plus"/>
                <span class="btn-box-text">添加附件</span>
              </div>
            </button>
            <div class="fileList">
              <div class="file-item van-hairline--bottom" v-for="(item,index) of filesList" :key="index">
                <img v-if="item.type.indexOf('image')>-1" :src="imgImgUrl" alt="">
                <img v-else :src="fileImgUrl" alt="">
                <div class="fileL">
                  <div class="fileName">
                    {{item.name}}
                  </div>
                  <div class="fileSize">
                    {{item.size / 1024 / 1024>=1?(item.size / 1024 / 1024).toFixed(2)+'MB':(item.size / 1024).toFixed(2)+'KB'}}
                  </div>
                </div>
                <van-icon name="cross" @click="delFiles(index)" color='#fff' size='1.6vw' style="background: #f87c7c; border-radius: 50%; border: 1.2vw solid #f87c7c;" />
              </div>
            </div>
          </div>
        </div>
        <div class="foot-btn van-hairline--top">
          <van-button round type="info" @click="submitBtn">发送</van-button>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
const fileImgUrl = require("@/assets/operationalAnalysis/file_s.png");
const imgImgUrl = require("@/assets/operationalAnalysis/img_s.png");
export default {
  name:'Reply',
  inject:['reload'],
  props:{
    isShowReply: {
      type: Boolean
    },
    id: {
      type: Number
    },
    list: {
      
    }
  },
  watch: {
    'isShowReply': {
        handler (newValue) {
          this.showReply = newValue
        },
        deep: true
      }
  },
  data(){
    return{
      totalMB: 0,
      fileImgUrl: fileImgUrl,
      imgImgUrl: imgImgUrl,
      pepList:[],
      message: '',
      filesMaxNumKB: 0,
      filesMaxNumMB: 0,
      filesMaxNumKBFixed: 0,
      filesMaxNumMBFixed: 0,
      filesList: [],
      docTypes: ['rar', 'zip', 'png', 'jpg', 'jpeg', 'svg', 'gif', 'flash', 'doc', 'docx', 'dotx', 'dot', 'pdf', 'txt', 'xml', 'ppt', 'pptx', 'xls', 'xlsx', 'xlst'],
      stopClickLogin:true,
      apiPath: this.xyMApi + '/oa',
      showReply: false
    }
  },
  methods:{
    close(){
      this.$emit("listenToChildClose", false);
    },
    submitBtn(){
      let _ = this
      if(this.totalMB > 100){
        this.xy.unloading()
        this.xy.msgError('附件总大小不能超过100M')
      } else {
        if(this.stopClickLogin){
          this.stopClickLogin = false
          if(this.filesList.length === 0 && !this.message){
            this.xy.msgError('批复或文件内容不能为空')
          } else {
            this.Create()
          }
          setTimeout(() => {
            _.stopClickLogin = true
          },2000)
        }

      }
    }, 
    async Create(){
      this.xy.loading()
      let formData = new FormData()
      for (let i = 0, len = this.filesList.length; i < len; i++) {
        formData.append('file', this.filesList[i])
      }
      if(this.filesList.length !== 0){
        let res = await this.xyapi.post(`${this.apiPath}/api/DocCirculation/UploadCommentFile`, formData, true)
        if(res.success){
          this.createFile(res.data)
        }
      } else {
        this.createFile()
      }
      
    },
    async createFile (returnFilesData) {
      let option = {
        DocumentID: this.$route.query.docID,
        CreatedByID: this.$route.query.creID,
        Title: this.list.DocumentInfo.Title,
        Comment: this.message, // 批复
        FileInfo: returnFilesData // 附件集合
      }
      let res = await this.xyapi.post(`${this.apiPath}/api/DocCirculation/AddComment`, option, true)
      if(res.success){
        this.xy.msgSuc('添加批复成功')
        var _ = this
        setTimeout(() => {
          _.reload()
        },100)
      } else {
        this.xy.msgError(res.msg)
      }
      this.xy.unloading()
    },
    changeFunc(e){
        for (var i = 0; i < e.target.files.length; i++) {
          let splitType = e.target.files[i].name.split('.')
          if (this.docTypes.indexOf(splitType[splitType.length - 1]) < 0) {
            this.xy.msgError('上传文件格式错误')
            return
          }
        }
        this.totalMB = 0
        this.filesList = [...this.filesList, ...e.target.files]
        for (let i = 0, len = this.filesList.length; i < len; i++) {
          if (this.filesList[i].isDel === undefined || !this.filesList[i].isDel) {
            this.$set(this.filesList[i], 'isDel', false)
            this.totalMB += this.filesList[i].size / 1024 / 1024
          }
        }
    },
    delFiles(itemIndex){
        this.$set(this.filesList[itemIndex], 'isDel', true)
        let isDelLen = this.filesList.filter(item => {
          return !item.isDel
        })
        this.filesList = isDelLen
        this.totalMB = 0
        for (let i = 0, len = this.filesList.length; i < len; i++) {
          if (!this.filesList[i].isDel) {
            this.totalMB += this.filesList[i].size / 1024 / 1024
          }
        }
        if (isDelLen.length === 0) {
          this.$refs.fileAll.value = null
        }
    }
  }
}
</script>

<style lang="less" scoped>
.add-pep{
  display: flex;
  flex-direction: column;
  position: relative;

}
.reply-wrap{
  margin-top: 20px;
  padding: 24px 30px 0;
  background: #fff;
  min-height: 1346px;
  .text{
    min-height: 392px;
  }
  .addFile{
    padding-top: 21.5px;
    position: relative;
    .fileList{
      padding-bottom: 10.4vh;
    }
    .add-btn{
      margin-bottom: 43px;
      border: 1px solid #2980FE;
      width: 210px;
      height: 68px;
      border-radius: 68px;
      background: #fff;
      color: #2980fe;
      position: relative;
      .btn-box{
        display: flex;
        align-items: center;
        justify-content: center;
        .btn-box-text{
          margin-left: 13px;
        }
      }
    }
    .file-item{
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-top: 40px;
      padding-bottom: 38px;
      img{
        width: 35px;
        height: 42px;
      }
      .fileL{
        width: 517px;
        margin: 0  65px 0 36px;
        .fileName{
          overflow: hidden;
          text-overflow:ellipsis;
          white-space: nowrap;
          font-size:28px;
          line-height: 32px;
          font-family:PingFang SC;
          color:rgba(0,0,0,1);
          margin-bottom: 10px;
          width: 507px;
        }
        .fileSize{
          font-size:26px;
          color:rgba(0,0,0,1);
          opacity:0.45;
          line-height: 26px;
        }
      }
      .fileR{
        width: 36px;
        height: 0;
        padding-bottom: 36px;
        background:rgba(248,124,124,1);
        border-radius:50%;
        color: #fff;
        text-align: center;
        line-height: 100%;
      }
    }
  }
}
.foot-btn{
  display: flex;
  padding: 16px 20px;
  background: #fff;
  bottom: 0;
  left: 0;
  right: 0;
  height: 9vh;
  position: fixed;
  font-size: 30px;
  button{
    flex-grow: 1;
    height: 88px;
  }
}
</style>
